/** @format */

import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
  selector: 'compare-no-products',
  templateUrl: './no-products.component.html',
  imports: [HmfButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoProductsToCompareComponent {
  readonly closeDrawer = output<void>();

  onCloseDrawer(): void {
    this.closeDrawer.emit();
  }
}
